import '../../style/default.css';
import './index.css'; // style dependencies
// deps-lint-skip: layout

import '../../tooltip/style/css';